import styled from "styled-components";
// Constants
import { bodyColor, errorColor } from "../config/constants";

const SelectDiv = styled.div`
  position: relative;
`;
const Select = styled.select`
  padding: ${({ padding }) => padding};
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  border: ${({ error }) => (error ? `1px solid ${errorColor}` : `1px solid ${bodyColor}`)};
  border-radius: 5px;
  font-size: 14px;
  background-image: url(${({ arrowImg }) => arrowImg});
  background-repeat: no-repeat;
  background-position: ${({ backgroundPosition }) => backgroundPosition};
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
  outline: none;
  cursor: ${({ disabled }) => (disabled ? "auto" : "pointer")};
  &:-ms-expand {
    display: none;
  }
`;
const SeparatorDiv = styled.div`
  width: 2px;
  height: 100%;
  background-color: ${bodyColor};
  position: absolute;
  top: 0;
  right: 32px;
`;

const SelectInput = ({ children, value, onChange, padding, width, height, arrowImg, backgroundPosition, error, disabled }) => (
  <SelectDiv>
    <Select
      value={value}
      onChange={onChange}
      padding={padding}
      width={width}
      height={height}
      arrowImg={arrowImg}
      backgroundPosition={backgroundPosition}
      error={error}
      disabled={disabled}
    >
      {children}
    </Select>
    <SeparatorDiv />
  </SelectDiv>
);

export default SelectInput;
